export const getOrder = (state) => state.order.order;
export const getOrderCountry = (state) => state.order.order?.salesInfo?.country;
export const getOrderSupplierType = (state) => state.order.order?.supplierType;
export const getOrderId = (state) => state.order.order?.orderId;
export const getOrderFetchStatus = (state) => state.order.fetchStatus;
export const getAddOnOrder = (state) => state.order.addOnOrder;
export const getNoOfAdults = (state) => state.order.order?.passengers.filter((p) => p.type === "ADULT").length;
export const getNoOfChildren = (state) => state.order.order?.passengers.filter((p) => p.type === "KID").length;
export const getFlightSegments = (state) => state.order.order?.airOrder.flightSegments;
export const getArrivalPlace = (state) => state.order.order?.airOrder.flightSegments?.[0]?.arrivalAirport;
export const getTripType = (state) => state.order.order?.airOrder.flightSegments &&
    state.order.order?.airOrder.flightSegments.length > 0 &&
    state.order.order?.airOrder.flightSegments.length === 1
    ? "ONEWAY"
    : state.order.order?.airOrder.flightSegments?.length === 2
        ? "ROUNDTRIP"
        : "MULTISTOP";
export const getLastDepartureDate = (state) => getTripType(state) === "ROUNDTRIP"
    ? state.order.order?.airOrder.flightSegments?.[state.order.order?.airOrder.flightSegments.length - 1].arrivalTime?.split("T")[0]
    : state.order.order?.airOrder.flightSegments?.[0].departureTime?.split("T")[0];
export const getArrivalCountryCode = (state) => state.order.order?.airOrder.flightSegments?.[0].arrivalAirport.country;
export const getOrderStatus = (state) => state.order.order?.orderStatus;
export const getOrderBookedAt = (state) => state.order.order?.airOrder.bookedAt;
export const getOrderCurrency = (state) => state.order.order?.orderCurrency;
export const getOrderToken = (state) => state.order.orderCreated?.orderToken;
export const getOrderFrequentFlyerEligibility = (state) => {
    const order = getOrder(state);
    const eligibilities = order?.frequentFlyerNumberEligibilities;
    return Array.isArray(eligibilities) && eligibilities.length === 1 ? eligibilities[0] : undefined;
};
export const getOrderPrivacyPolicyUrl = (state) => state.order.order?.orderTerms?.booking.privacyUrl;
export const getIsOrderCompleted = (state) => state.order.order?.isCompleted;
export const getOrderSlice = (state) => state.order;
export const getOrderCreated = (state) => state.order.orderCreated;
export const getOrderError = (state) => state.order.error;
